/*
 * Pipeline Theme - Custom JavaScript
 * 
 * Appstle Subscription Widget Support:
 * - Reinitializes widget after variant changes (Section Rendering API compatibility)
 * - Syncs selling plan prices to Add to Cart button
 */

(function() {
  'use strict';

  // ==========================================================================
  // APPSTLE WIDGET REINITIALIZATION
  // ==========================================================================

  var reinitInProgress = false;
  var variantChangeTimeout = null;

  /**
   * Reinitialize Appstle subscription widget after variant change
   */
  function reinitializeAppstle() {
    if (reinitInProgress) return;
    reinitInProgress = true;

    var selectors = document.querySelectorAll('.appstle_stand_alone_selector');
    
    if (selectors.length === 0) {
      reinitInProgress = false;
      return;
    }

    // Remove processed class to allow reinitialization
    selectors.forEach(function(selector) {
      selector.classList.remove('appstle_stand_alone_selector_processed');
    });

    // Remove any orphaned widgets outside the selector
    var orphanedWidgets = document.querySelectorAll('.appstle_sub_widget');
    orphanedWidgets.forEach(function(widget) {
      if (!widget.closest('.appstle_stand_alone_selector')) {
        widget.remove();
      }
    });

    // Try Appstle initialization methods
    if (typeof window.pollAppstleInit === 'function') {
      try {
        window.pollAppstleInit();
      } catch (e) {
        console.warn('[Appstle] pollAppstleInit failed:', e);
      }
    } else if (typeof window.appstleInit === 'function') {
      try {
        window.appstleInit();
      } catch (e) {
        console.warn('[Appstle] appstleInit failed:', e);
      }
    }

    // Wait for widget to load, then setup price sync
    waitForWidget(function() {
      setupSellingPlanPriceSync();
      observeAppstleChanges();
      reinitInProgress = false;
    });
  }

  /**
   * Wait for Appstle widget to be fully rendered
   */
  function waitForWidget(callback, attempts) {
    attempts = attempts || 0;
    var maxAttempts = 50;

    var wrapper = document.querySelector('.appstle_subscription_wrapper');
    var hasContent = wrapper && wrapper.querySelector('input[name="selling_plan"]');

    if (hasContent) {
      setTimeout(callback, 50);
    } else if (attempts < maxAttempts) {
      setTimeout(function() {
        waitForWidget(callback, attempts + 1);
      }, 100);
    } else {
      // Timeout - continue anyway
      reinitInProgress = false;
    }
  }

  // ==========================================================================
  // SELLING PLAN PRICE SYNC
  // ==========================================================================

  // CSS for strikethrough pricing on Add to Cart button
  var priceStyles = document.createElement('style');
  priceStyles.textContent = [
    '.btn-price-wrapper {',
    '  display: inline-flex;',
    '  align-items: center;',
    '  gap: 6px;',
    '}',
    '.btn-price-compare {',
    '  text-decoration: line-through;',
    '  opacity: 0.6;',
    '  font-size: 0.9em;',
    '}'
  ].join('\n');
  document.head.appendChild(priceStyles);

  /**
   * Setup event listeners for selling plan changes
   */
  function setupSellingPlanPriceSync() {
    var radios = document.querySelectorAll('input[name="selling_plan"]');
    var frequencySelect = document.querySelector('.appstle_select');

    radios.forEach(function(radio) {
      if (!radio.dataset.priceSyncBound) {
        radio.addEventListener('change', updateButtonPrice);
        radio.dataset.priceSyncBound = 'true';
      }
    });

    if (frequencySelect && !frequencySelect.dataset.priceSyncBound) {
      frequencySelect.addEventListener('change', updateButtonPrice);
      frequencySelect.dataset.priceSyncBound = 'true';
    }

    // Initial price update
    setTimeout(updateButtonPrice, 100);
  }

  /**
   * Update Add to Cart button price based on selected selling plan
   */
  function updateButtonPrice() {
    var buttonPrice = document.querySelector('[data-button-price]');
    if (!buttonPrice) return;

    var selectedRadio = document.querySelector('input[name="selling_plan"]:checked');
    var isSubscription = selectedRadio && selectedRadio.value;

    if (isSubscription) {
      // Subscription selected - show compare price + sale price
      var saleEl = document.querySelector(
        '.appstle_subscription_wrapper_option.appstle-active-option ' +
        '.appstle_subscription_amount:not(.sr-only):not(.appstle_subscription_compare_amount)'
      );
      var compareEl = document.querySelector(
        '.appstle_subscription_wrapper_option.appstle-active-option ' +
        '.appstle_subscription_compare_amount'
      );

      if (saleEl) {
        var salePrice = saleEl.textContent.trim();
        var comparePrice = compareEl ? compareEl.textContent.trim() : null;

        if (comparePrice && comparePrice !== salePrice) {
          buttonPrice.innerHTML = 
            '<span class="btn-price-wrapper">' +
            '<span class="btn-price-compare">' + comparePrice + '</span>' +
            '<span class="btn-price-sale">' + salePrice + '</span>' +
            '</span>';
        } else {
          buttonPrice.textContent = salePrice;
        }

        updateAlpinePrice(salePrice);
      }
    } else {
      // One-time purchase selected
      var oneTimeEl = document.querySelector(
        '.appstle_one_time_details_wrapper .appstle_subscription_amount:not(.sr-only)'
      );

      if (oneTimeEl) {
        var price = oneTimeEl.textContent.trim();
        buttonPrice.textContent = price;
        updateAlpinePrice(price);
      }
    }
  }

  /**
   * Sync price with Alpine.js state if available
   */
  function updateAlpinePrice(priceText) {
    var match = priceText.match(/[\d,.]+/);
    if (!match) return;

    var priceValue = parseFloat(match[0].replace(',', '')) * 100;
    var form = document.querySelector('[data-product-form]');

    if (form && form.__x && form.__x.$data) {
      form.__x.$data.price = priceValue;
    } else if (form && window.Alpine) {
      var data = window.Alpine.$data(form);
      if (data) data.price = priceValue;
    }
  }

  /**
   * Observe Appstle widget for class changes (option selection)
   */
  var appstleObserver = null;

  function observeAppstleChanges() {
    if (appstleObserver) {
      appstleObserver.disconnect();
    }

    var wrapper = document.querySelector('.appstle_subscription_wrapper');
    if (!wrapper) return;

    appstleObserver = new MutationObserver(function() {
      clearTimeout(observeAppstleChanges.debounce);
      observeAppstleChanges.debounce = setTimeout(updateButtonPrice, 50);
    });

    appstleObserver.observe(wrapper, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });
  }

  // ==========================================================================
  // EVENT LISTENERS
  // ==========================================================================

  /**
   * Listen for theme variant change events
   */
  document.addEventListener('theme:variant:change', function(event) {
    if (event.detail && event.detail.variant) {
      clearTimeout(variantChangeTimeout);
      variantChangeTimeout = setTimeout(reinitializeAppstle, 250);
    }
  });

  /**
   * Setup MutationObserver to detect section re-renders
   */
  function setupSectionObserver() {
    var productSection = document.querySelector(
      '[data-product-container], .product-section, [data-section-type="product"]'
    );

    if (!productSection) return;

    var observer = new MutationObserver(function(mutations) {
      if (reinitInProgress) return;

      var shouldReinit = mutations.some(function(mutation) {
        return Array.from(mutation.addedNodes).some(function(node) {
          if (node.nodeType !== 1) return false;
          return node.classList && node.classList.contains('appstle_stand_alone_selector') ||
                 node.querySelector && node.querySelector('.appstle_stand_alone_selector');
        });
      });

      if (shouldReinit) {
        clearTimeout(variantChangeTimeout);
        variantChangeTimeout = setTimeout(reinitializeAppstle, 250);
      }
    });

    observer.observe(productSection, {
      childList: true,
      subtree: true
    });
  }

  // ==========================================================================
  // INITIALIZATION
  // ==========================================================================

  function init() {
    setupSectionObserver();

    // Setup price sync after initial widget load
    waitForWidget(function() {
      setupSellingPlanPriceSync();
      observeAppstleChanges();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.appstle_stand_alone_selector')) {
      setTimeout(reinitializeAppstle, 100);
    }
  });

})();
